module.exports = __webpack_public_path__ + "static/safe@2x-d931287017c9be2a419c047fc105ddda.png";